module.exports = __webpack_public_path__ + "assets/img/2_806.9edc0b52.jpg";